export default __webpack_public_path__ + "static/media/quie-step-3.59ccb656.svg";